import React from 'react';
import './WebService.css';

function WebService() {
  return (
    <div className="web-section">
      <div className="background-img">
        <div className="ctent">
          <h1 className="display-4">Our Services </h1>

        </div>
      </div>
    </div>
  );
}

export default WebService;
